import './users.less'
import { useState, useEffect } from 'react'

interface PropsTypes {
  lang: Lang
}

interface AboutUsItem {
  imgUrl: string,
  name: string,
  location: string,
  content: string,
  alt: string
}

const ABOUT_US_LIST: AboutUsItem[] = [
  {
    imgUrl: require('../../img/users/corey_m_rand.png'),
    name: __('Shopify Store Owner'),
    location: __('US'),
    content: __(
      'I sell mostly apparel on my Shopify store. The useful and powerful BuckyDrop features like Order Auto-Fulfillment and Customized In-warehouse Service help me a lot in running my store, particularly custom packaging and tag replacement. After joining BuckyDrop, I built my own brand and saw a 108% surge in order volume. Nowadays, I’ve got a daily turnover between $2500 and $3000.'
    ),
    alt: 'buckydrop dropshipping corey m rand united states',
  },
  {
    imgUrl: require('../../img/users/fiona_xie.png'),
    name: __('E-commerce Rookie'),
    location: __('South Korea'),
    content: __(
      'I’m a big fan of esports, and I stepped into e-commerce just hoping to sell some esports stuff online. As a rookie, I turned to Manual Operation Service from BuckyDrop, which helped bring in lots of visitors to my store. Meanwhile, with BuckyDrop taking care of marketing for me, I got the first order several days later! This gave me much confidence that I can make my e-business a great success!'
    ),
    alt: 'buckydrop dropshipping fiona xie singapore',
  },
  {
    imgUrl: require('../../img/users/cart.svg'),
    name: __('Global E-commerce Platform'),
    location: '',
    content: __(
      'I am the owner of a dedicated e-platform. The one-stop supply chain solution from BuckyDrop enables hassle-free integration with various modules including Product, Order, Parcel and Logistics through the Open API, which frees us from the burden of dealing with multiple service providers. Plus, it helps us greatly diversify our product offerings, and now Chinese products are seeing a 55% increase in sales.'
    ),
    alt: 'buckydrop dropshipping ruby sligo australia',
  },
  {
    imgUrl: require('../../img/users/jaana_jokinen.png'),
    name: __('Physical Store Owner'),
    location: __('South Africa'),
    content: __(
      'I run a physical store in South Africa, mostly selling clothes and socks. With the highly cost-competitive logistics service from BuckyDrop, I can source from somewhere else and get the products delivered to my store for further sale. In the coming days, I will give a try to its order fulfillment service, hoping to make the sourcing part easier and faster.'
    ),
    alt: 'buckydrop dropshipping jaana jokinen finland',
  },
]

function Users (props: PropsTypes): JSX.Element {
  const { lang } = props
  const [index, setIndex] = useState(0)
  const canSlideNum = (ABOUT_US_LIST.length / 2) - 1 // 可滑动次数

  const toLeft = () => {
    // 到 0 之后不可再减
    if (index !== 0) {
      const usersContent = document.getElementById('users_content') as HTMLElement
      usersContent.style.right = `${1200 * (index - 1)}px`
      setIndex(index - 1)
    }
  }

  const toRight = () => {
    // 到最大滑动次数时不可再增
    if (index < canSlideNum) {
      const usersContent = document.getElementById('users_content') as HTMLElement
      usersContent.style.right = `${1200 * (index + 1)}px`
      setIndex(index + 1)
    }
  }

  useEffect(() => {
    const usersContent = document.getElementById('users_content') as HTMLElement
    usersContent.style.width = `${1200 * (ABOUT_US_LIST.length - 2)}px`
  })

  return (
    <div className={`users ${lang}`}>
      <h2 className='users_title'>{__('What are users saying about us?')}</h2>
      <div className='users_outerContainer'>
        <img className={`users_arrowLeft ${index === 0 ? 'users_arrowLeft_none' : ''}`} src={`${index === 0 ? require('../../img/arrow_left_gray.svg') : require('../../img/arrow_left.svg')}`} alt='buckydrop dropshipping arrow' onClick={toLeft} />
        <img className={`users_arrowRight ${index === canSlideNum ? 'users_arrowRight_none' : ''}`} src={`${index === canSlideNum ? require('../../img/arrow_right_gray.svg') : require('../../img/arrow_right.svg')}`} alt='buckydrop dropshipping arrow' onClick={toRight} />
        <div className='users_container'>
          <div className='users_content' id='users_content' >
            {
              ABOUT_US_LIST.map((item, index) => (
                <div className='users_box' key={index}>
                  <div className='users_box_Wrap'>
                    <img className='users_box_Wrap_img' src={item.imgUrl} alt={item.alt} />
                    <p className='users_box_Wrap_name'>{item.name}</p>
                    {item.location && <p className='users_box_Wrap_desc'>{item.location}</p>}
                  </div>
                  <p className='users_box_desc'>{item.content}</p>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Users
